import { searchIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Search = createIcon({
  displayName: 'Search',
  paths: [
    'M448 640c-105.856 0-192-86.144-192-192s86.144-192 192-192c105.856 0 192 86.144 192 192s-86.144 192-192 192zM821.035 760.704l-149.291-149.291c33.536-45.867 53.589-102.229 53.589-163.413 0-153.173-124.16-277.333-277.333-277.333s-277.333 124.16-277.333 277.333c0 153.173 124.16 277.333 277.333 277.333 61.184 0 117.547-20.053 163.413-53.589l149.291 149.291c16.64 16.64 43.648 16.64 60.331 0 16.64-16.683 16.64-43.691 0-60.331z'
  ],
  canvasPaths: canvasIconPaths(searchIcon)
})
